// src/pages/ReportsPage.tsx
import { useState } from "react";
import AchievementCharts from '@/components/reports/AchievementCharts';
import EmergencyCards from '@/components/reports/EmergencyCards';
import ActionForm from '@/components/reports/ActionForm';
import EmergencyForm from '@/components/reports/EmergencyForm';
import KeyMetrics from '@/components/reports/KeyMetrics';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useAuthStore } from "@/store/authStore";

export default function ReportsPage() {
  const { user } = useAuthStore();
  const isMe = user && (user.id === 4 || user.id === "4");

  const [openAction, setOpenAction] = useState(false);
  const [openEmergency, setOpenEmergency] = useState(false);
  const [openAddMetric, setOpenAddMetric] = useState(false);   // ← новое состояние

  return (
    <div className="p-8 md:p-10 min-h-screen bg-gradient-to-br from-slate-950 via-purple-950 to-indigo-950">
      {/* Заголовок */}
      <h1 className="text-4xl md:text-5xl font-bold text-white mb-8 md:mb-12 text-center bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
        Отчеты ОРВ ВСКС
      </h1>

      {/* Кнопки управления — только для Павлика */}
      {isMe && (
        <div className="flex flex-wrap justify-center gap-6 mb-12">
          {/* Добавить новую акцию */}
          <Dialog open={openAction} onOpenChange={setOpenAction}>
            <DialogTrigger asChild>
              <Button
                size="lg"
                className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white text-xl md:text-2xl px-10 md:px-16 py-6 md:py-8 rounded-2xl shadow-2xl shadow-purple-600/50 transition-all duration-300 hover:scale-105"
              >
                + Добавить новую акцию
              </Button>
            </DialogTrigger>

            <DialogContent className="sm:max-w-[600px] bg-gradient-to-b from-purple-950 to-indigo-950 border-purple-700/50 text-white max-h-[90vh] overflow-y-auto">
              <DialogHeader>
                <DialogTitle className="text-2xl md:text-3xl font-bold text-purple-200 mb-6">
                  Новая акция
                </DialogTitle>
              </DialogHeader>
              <ActionForm onClose={() => setOpenAction(false)} />
            </DialogContent>
          </Dialog>

          {/* Добавить ЧС */}
          <Dialog open={openEmergency} onOpenChange={setOpenEmergency}>
            <DialogTrigger asChild>
              <Button
                size="lg"
                className="bg-gradient-to-r from-red-600 to-rose-600 hover:from-red-700 hover:to-rose-700 text-white text-xl md:text-2xl px-10 md:px-16 py-6 md:py-8 rounded-2xl shadow-2xl shadow-red-600/50 transition-all duration-300 hover:scale-105"
              >
                + Добавить ЧС
              </Button>
            </DialogTrigger>

            <DialogContent className="sm:max-w-[500px] bg-gradient-to-b from-purple-950 to-indigo-950 border-purple-700/50 text-white">
              <DialogHeader>
                <DialogTitle className="text-2xl md:text-3xl font-bold text-purple-200 mb-6">
                  Новая чрезвычайная ситуация
                </DialogTitle>
              </DialogHeader>
              <EmergencyForm onClose={() => setOpenEmergency(false)} />
            </DialogContent>
          </Dialog>

          {/* ←←← ВЕРХНЯЯ КНОПКА "ДОБАВИТЬ ПОКАЗАТЕЛЬ" ←←← */}
          <Button
            size="lg"
            onClick={() => setOpenAddMetric(true)}
            className="bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white text-xl md:text-2xl px-10 md:px-16 py-6 md:py-8 rounded-2xl shadow-2xl shadow-emerald-600/50 transition-all duration-300 hover:scale-105"
          >
            + Добавить показатель
          </Button>
        </div>
      )}

      {/* Блок ключевых показателей (без своей кнопки) */}
      <KeyMetrics openAddMetric={openAddMetric} setOpenAddMetric={setOpenAddMetric} />

      {/* Графики акций */}
      <AchievementCharts />

      {/* Карточки ЧС */}
      <EmergencyCards />
    </div>
  );
}